import { CourseStatus } from '../models/course-status';

/**
 * Map to course status.
 * @param {object} dto Dto.
 * @returns {CourseStatus}
 */
function fromDto(dto) {
  return new CourseStatus({
    name: dto.name,
    value: dto.value,
  });
}

export const courseStatusMapper = {
  fromDto,
};
